import { sendEmail } from '../../lib/api/send-email'
import { SendEmailInput } from '../../lib/types/models/mail/create-mail-attachment'
import { IdsInput } from '../../lib/types/utils'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendEmailToMissionTrackings(input: SendEmailInput) {
  return sendEmail(API.missionTrackings.sendEmail.url, input)
}

export function sendMissionFriendlyContractReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(API.missionTrackings.sendMissionFriendlyContractReminder.url)
    .post(input)
}

export function sendMissionFinalContractReminderToStaffs(input: IdsInput) {
  return restApiClient.url(API.missionTrackings.sendMissionFinalContractReminder.url).post(input)
}

export function sendMissionFriendlyMissingDocumentsReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(API.missionTrackings.sendMissionFriendlyMissingDocumentsReminder.url)
    .post(input)
}

export function sendMissionFinalMissingDocumentsReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(API.missionTrackings.sendMissionFinalMissingDocumentsReminder.url)
    .post(input)
}

export function sendMissionReportReminderToStaffs(input: IdsInput) {
  return restApiClient.url(API.missionTrackings.sendMissionReportReminder.url).post(input)
}
